import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {styles} from './styles';
import ConfirmationDialog from '../../../common/confirmationDialog';
import {createCity, updateCity} from '../../../../actions/cities';
import {getProvinces} from '../../../../actions/provinces';


const CityDetails = (props) => {
  const [cityDetail, setCity] = useState({
    active: true,
    name: '',
    province: '',
    code: '',
  });

  const {provinces} = useSelector(state => state.provinces);

  const dispatch = useDispatch();

  useEffect(() => {
    const {isNew, city} = props;
    dispatch(getProvinces());
    if (!isNew) {
      setCity(city);
    }
  }, []);

  const onAddButtonClick = async () => {
    const {name, province, code} = cityDetail;
    await dispatch(createCity({name, province, code}));
    props.handleGoBack();
  };

  const onEditButtonClick = async () => {
    const {city} = props;
    const {name, active, province, code} = cityDetail;
    await dispatch(updateCity(city.id, {name, active, province, code}));
    props.handleGoBack();
  };

  const handleChangeCity = (e) => {
    const {value, name} = e.target;
    setCity((prevState) => {
      return {...prevState, [name]: value};
    });
  };


  const isInvalid = () => {
    const {name, province} = cityDetail;
    if (name !== '' && province !== '') {
      return false;
    }
    return true;
  };

  const renderButton = () => {
    const {isLoading, isNew, classes} = props;
    if (!isLoading) {
      return (
        <ConfirmationDialog 
          confirmationText={`¿Está seguro que desea ${isNew ? 'crear' : 'modificar'} esta ciudad?`}
          buttonText={`${isNew ? 'Agregar' : 'Actualizar'} ciudad`}
          variant="contained"
          isDisabled={isInvalid()}
          confirmAction={isNew ? onAddButtonClick : onEditButtonClick}
        />
      );
    }
    return <CircularProgress className={classes.progress} />;
  };

  const renderProvinces = () => {
    return provinces.map((item, index) => {
      return (
        <MenuItem value={item.id} key={index}>{item.name}</MenuItem>
      );
    });
  }; 

  const renderRowProvince = () => {
    const {classes} = props;
    return (
      <TableRow>
        <TableCell className={classes.tableRowTitle}><b>Provincia</b></TableCell>
        <TableCell>
          <Select
            name="province"
            value={cityDetail.province}
            fullWidth
            onChange={handleChangeCity}
          >
            {renderProvinces()}
          </Select>
        </TableCell>
      </TableRow>
    );
  };


  const {classes, isLoading, isNew, handleGoBack} = props;
  return isLoading === true ? <CircularProgress style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto'}} /> : (
    <Paper elevation={2} className={classes.paperRoot}>
      <Toolbar>
        <IconButton onClick={handleGoBack}>
          <ArrowBackIosIcon />
        </IconButton>
        <Typography variant="h6">
          {!isNew ? 'Detalle de ' : 'Nueva '} ciudad
        </Typography>
      </Toolbar>
      <div style={{width: 'auto', overflowX: 'scroll'}}>
        <Table>
          <TableBody>
            {
              !isNew &&
              <TableRow>
                <TableCell className={classes.tableRowTitle}><b>Disponible</b></TableCell>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={cityDetail.active}
                        onChange={e => setCity((prevState) => {
                          return {...prevState, active: e.target.checked};
                        })}
                        color="primary"
                      />
                    }
                    label={cityDetail.active === true ? 'Disponible' : 'No disponible'}
                  />
                </TableCell>
              </TableRow>
            }
            <TableRow>
              <TableCell className={classes.tableRowTitle}><b>Nombre</b></TableCell>
              <TableCell>
                <TextField 
                  autoFocus
                  name="name"
                  value={cityDetail.name}
                  onChange={handleChangeCity}
                  fullWidth
                />
              </TableCell>
            </TableRow>
            {renderRowProvince()}  
            <TableRow>
              <TableCell className={classes.tableRowTitle}><b>Código</b></TableCell>
              <TableCell>
                <TextField 
                  autoFocus
                  name="code"
                  value={cityDetail.code}
                  onChange={handleChangeCity}
                  fullWidth
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div className={classes.submitContainer}>
        {renderButton()}
      </div>
    </Paper>
  );
};

CityDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isNew: PropTypes.bool.isRequired,
  city: PropTypes.object.isRequired,
  handleGoBack: PropTypes.func.isRequired
};

export default (withStyles(styles)(CityDetails));
